module.exports = __webpack_public_path__ + "img/icon_home.dfb2275b.svg";